import axios from 'axios';

const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

export const changeAuth = (auth: string) => {
  api.defaults.headers.common.Authorization = auth;
};

const authLocal: string | null = localStorage.getItem('user');

if (authLocal) {
  changeAuth(`bearer ${JSON.parse(authLocal).token}`);
}

export default api;
